// import React from 'react'

// const ExecutiveResetPassword = () => {
//   return (
//     <div>
//       ExecutiveResetPassword
//     </div>
//   )
// }

// export default ExecutiveResetPassword


import React, { useEffect, useState } from 'react'
import { Link, NavLink, useNavigate, useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import styled from 'styled-components';
import { GoogleLogin } from '@react-oauth/google';
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

const ExecutiveResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [email,setEmail]=useState('')
    const [token,setToken] =useState('')
    const [searchParams] = useSearchParams();

    const navigate = useNavigate();

    useEffect(()=>{
        // console.log(searchParams)
        // console.log(searchParams.get('email'))
        // console.log(searchParams.get('token'))
        
        const email = searchParams.get('email')
        const token = searchParams.get('token')

        const details={
          email:email,
          token:token
        }
        // console.log(details)
        if(email && token){
          localStorage.setItem('tokenDetails',JSON.stringify(details))
          navigate('/api/BDExecutive/reset-password')
        }
        
        
        const data = localStorage.getItem('tokenDetails')
        if(data){
          const parseData = JSON.parse(data)
          if(email) setEmail(parseData.email)
          if(token) setToken(parseData.token)
        }
        

    },[searchParams])

    const [eyePassword, setEyePassword] = useState(false)
    const [confirmPasswordeyePassword, setConfirmPasswordEyePassword] = useState(false)

    const [showEyePassword, setShowEyePassword] = useState(false)
    const [confirmPasswordshowEyePassword, setConfirmPasswordShowEyePassword] = useState(false)

    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        if(confirmPassword !==  password){
          alert('Password and Confirm Password must be same')
          return
        }
        try {
            const response = await axios.post(' https://api.bakpoket.com/api/BDExecutive/reset-password', {
                email,
                token,
                newPassword:password
            });
            alert('Reset Password Successful');
            setPassword('')
            setConfirmPassword('')
            navigate('/executiveSignin')
            localStorage.removeItem('tokenDetails')
        } catch (error) {
            console.error('Reset password failed:', error);
            alert('Reset password failed');
        }
    };


    return (
        <Wrapper className='my-3'>
            <div className="login-main-card">
                <p className="top-text">Executive Reset Password</p>
                <form className="auth-form" onSubmit={handleLogin}>
                    <div style={{ position: 'relative' }}>
                        <input
                            type={showEyePassword ? 'type' : "password"}
                            placeholder="Password must contain 8 characters"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                if (e.target.value.length >= 8) setError('');
                            }}
                            required
                            style={{ width: '100%' }}
                        />
                        {password.length > 0 ? (
                            eyePassword ? (<FaEyeSlash style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setEyePassword(false); setShowEyePassword(false) }} />)
                                : (<FaEye style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setEyePassword(true); setShowEyePassword(true) }} />)) : (null)
                        }
                    </div>

                    <div style={{ position: 'relative' }}>
                        <input
                            type={confirmPasswordshowEyePassword ? 'type' : "password"}
                            placeholder="Confirm Password must contain 8 characters"
                            value={confirmPassword}
                            onChange={(e) => {
                                setConfirmPassword(e.target.value);
                                if (e.target.value.length >= 8) setError('');
                            }}
                            required
                            style={{ width: '100%' }}
                        />
                        {confirmPassword.length > 0 ? (
                            confirmPasswordeyePassword ? (<FaEyeSlash style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setConfirmPasswordEyePassword(false); setConfirmPasswordShowEyePassword(false) }} />)
                                : (<FaEye style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setConfirmPasswordEyePassword(true); setConfirmPasswordShowEyePassword(true) }} />)) : (null)
                        }
                    </div>
                    {error && <p className='mb-0' style={{ color: "red", fontSize: "12px" }}>{error}</p>}
                    <div className='d-flex gap-2'>
                        <button type="submit" className="auth-btn">Reset Password</button>
                        <button className="auth-btn"><Link style={{textDecoration:'none',color:'#fff'}} to="/">Cancel</Link></button>
                    </div>
                </form>
            </div>
        </Wrapper>
    )
}

export default ExecutiveResetPassword

const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;

  .login-main-card {
    background-color: rgb(233, 231, 231);
    width: 100%;
    max-width: 420px;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .top-text {
    font-weight: bold;
    color: #444;
    margin-bottom: 10px;
  }

  h2 {
    margin-bottom: 25px;
    color: #222;
  }

  .login-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 0px;
  }

  .login-type {
    display: flex;
    justify-content: center;
  }

  .or-divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 10px 0;

    span {
      background-color: rgba(71, 70, 70, 0.1);
      padding: 3px;
      color: #666;
      font-weight: 600;
      border-radius: 50%;
    }

    &::before,
    &::after {
      content: '';
      flex: 1;
      height: 1px;
      background: #999;
    }
  }

  .auth-form {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input {
      padding: 7px;
      border-radius: 6px;
      border: 1px solid #ccc;
      font-size: 13px;
    }
  }

  .auth-btn {
    background-color: #ef4766;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 6px;
    font-weight: bold;
    width: 100%;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
      background-color: #d91212;
    }
  }
`;

const SwitchText = styled.p`
  font-size: 13px;
  margin-top: 10px;
  margin-bottom: 0px;

  span {
    color: #ef4766;
    cursor: pointer;
    font-weight: bold;
  }

  @media (max-width: 600px) {
    font-size: 9px;
    margin-top: 2px;
    margin-bottom: 2px;
  }
`;





